import { useState, useCallback, FC } from "react";
import ApplyOnlineForm from "./ApplyOnlineForm/ApplyOnlineForm";
import "./style.scss";

interface IApplyOnline {
  loadActualForm: () => void | Promise<void>;
  onCloseForm?: () => void;
}

const ApplyOnline: FC<IApplyOnline> = ({ loadActualForm, onCloseForm }) => {
  const [stepStatus, setStepStatus] = useState<Record<string, string>>({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const handleStatusChange = useCallback((status: Record<string, string>) => {
    setStepStatus(status);
  }, []);

  return (
    <div className="apply-online">
      <div className="apply-online-steps">
        <div className="apply-online-step one">
          <div className={`apply-online-step-point one isWasEmpty ${stepStatus.one ? stepStatus.one : "empty"}`}></div>
          <span className={`apply-online-step-title one active ${stepStatus.one ? stepStatus.one : "empty"}`}>Quick Application</span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step two">
          <div className={`apply-online-step-point two ${stepStatus.two ? stepStatus.two : "empty"}`}></div>
          <span className={`apply-online-step-title two ${stepStatus.two ? stepStatus.two : "empty"}`}>Additional Information</span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step three">
          <div className={`apply-online-step-point three ${stepStatus.three ? stepStatus.three : "empty"}`}></div>
          <span className={`apply-online-step-title three ${stepStatus.three ? stepStatus.three : "empty"}`}>Program Details</span>
        </div>

        <div className="apply-online-steps-line"></div>

        <div className="apply-online-step four">
          <div className={`apply-online-step-point ${stepStatus.four ? stepStatus.four : "empty"}`}></div>
          <span className={`apply-online-step-title four ${stepStatus.four ? stepStatus.four : "empty"}`}>Successfully Submitted</span>
        </div>
      </div>

      <ApplyOnlineForm
        onSectionStatusChange={handleStatusChange}
        loadActualForm={loadActualForm}
        onCloseForm={onCloseForm}
      />
    </div>
  );
};

export default ApplyOnline;
